import {
	getRequest,
	postRequest
} from './requset.js'
import * as Url from "./Url";


/**
 *               @示例
 * 
 * 
export const shareRegisterReuqest = (paramObj,proxy) => {
    return getRequest(Url.REGISTER_URL, paramObj,proxy);
}

export const testReuqest = (paramObj,proxy) => {
    return getRequest(Url.TEST, paramObj,proxy);
}


export const loginReuqest = (paramObj,proxy) => {
    return getRequest(Url.LOGIN_URL, paramObj,proxy);
}
 * 
 * 
 * 
*/

/**
 * @校验验证码
*/ 
export const verifyCode = (paramObj) => {
	return postRequest(Url.HOST+'/auth/app/verifyCode', paramObj);
}

/**
 * @获取登录区号
*/ 
export const areaCodeList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/index/areaCodeList', paramObj);
}

/**
 * @校验账号是否已经注册
*/
export const exists = (paramObj) => {
	return getRequest(Url.HOST+'/auth/app/exists', paramObj);
}


/**
 * @获取用户信息
*/ 
export const getUserInfo = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/userInfo/getInfo', paramObj);
}

// 获取默认头像列表
export const getAvatarList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/userInfo/avatarList', paramObj);
}

// 更改用户的基础信息
export const setUserInfo = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userInfo', paramObj);
}
// 礼金转真金
export const giftToBalance = (params) => {
	return postRequest(Url.HOST+'/usermanage/userInfo/giftToBalance', params);
}


/**
 * @防沉迷
*/ 
// 设置防沉迷
export const setAddicted = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/addicted/set', paramObj);
}

// 获取防沉迷状态
export const getAddicted = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/addicted/get', paramObj);
}







/**
 * @登录
*/ 
// 登录绑定手机号/邮箱
export const bindMobile = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userInfo/bindMobile', paramObj);
}


// 登录 grantType区分  手机号||邮箱||临时账号||手机号验证码登录||邮箱验证码登录
export const codeLoginReuqest = (paramObj) => {
	return postRequest(Url.HOST+'/auth/app/login', paramObj);
}

// 发送短信验证码
export const sendSmsCode = (paramObj) => {
	return getRequest(Url.HOST+'/resource/sms/code', paramObj);
}

// 发送邮箱验证码
export const sendEmailCode = (paramObj) => {
	return getRequest(Url.HOST+'/resource/email/code', paramObj);
}

// 获取游客登录账号密码
export const touristAccount = (paramObj) => {
	return getRequest(Url.HOST+'/auth/app/touristAccount', paramObj);
}

// 游客注册
export const touristRegister = (paramObj) => {
	return postRequest(Url.HOST+'/auth/app/touristRegister', paramObj);
}




/**
 * @注册
*/ 

// 邮箱注册
export const emailRegister = (paramObj) => {
	return postRequest(Url.HOST+'/auth/app/emailRegister', paramObj);
}

// 手机号码注册
export const registerPhone = (paramObj) => {
	return postRequest(Url.HOST+'/auth/app/register', paramObj);
}



// 忘记密码
export const updatePassWord = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/index/updatePassWord', paramObj);
}

// 设置支付密码
export const updatePayPassWord = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userInfo/updatePayPassWord', paramObj);
}

// 设置支付密码
export const validatePayPin = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userInfo/validatePayPin', paramObj);
}

// 设置登录密码
export const updateLoginPassWord = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userInfo/updatePassWord', paramObj);
}








/**
 * @首页
*/ 
// 获取轮播图列表
export const getBannerList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/index/bannerList', paramObj);
}

// 获取游戏分类列表
export const getClassList = (paramObj) => {
	return getRequest(Url.HOST+'/game/games/classList', paramObj);
}

// 获取媒体分享列表
export const getList = () => {
	return getRequest(Url.HOST+'/usermanage/app_media_config/get_list');
}


// 获取游戏列表
export const getGameList = (paramObj) => {
	return getRequest(Url.HOST+'/game/games/page', paramObj);
}

// 获取游戏列表
export const goPlayGame = (paramObj) => {
	return postRequest(Url.HOST+'/game/games/play', paramObj);
}

// 获取经常搜索游戏列表
export const getOldSearchList = (paramObj) => {
	return getRequest(Url.HOST+'/game/games/searchList', paramObj);
}





// 获取收藏游戏列表
export const gameCollectList = (paramObj) => {
	return getRequest(Url.HOST+'/game/gameCollect/page', paramObj);
}

// 获取游戏详情
export const getGameDetails = (paramObj) => {
	return getRequest(Url.HOST+'/game/games/details', paramObj);
}

// 收藏游戏
export const addGameCollect = (paramObj) => {
	return postRequest(Url.HOST+'/game/gameCollect/add', paramObj);
}

// 取消收藏游戏
export const cancelGameCollect = (paramObj) => {
	return postRequest(Url.HOST+'/game/gameCollect/cancel', paramObj);
}



/**
 * @签到
*/ 
//获取签到信息
export const getSignInfo = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/signInfo/getInfo', paramObj);
}

//每日签到
export const signInfo = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/signInfo/sign', paramObj);
}



/**
 * @活动
*/ 
// 获取vip奖励信息
export const vipLevelInfo = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/vipLevel/info', paramObj);
}

// 领取vip奖励
export const claimReward = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/vipLevel/claimReward', paramObj);
}

// 领取vip4周奖励
export const weeklyRewards = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/vipLevel/weeklyRewards', paramObj);
}
// 领取vip8周奖励
export const monthlyRewards = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/vipLevel/monthlyRewards', paramObj);
}


/**
 * @消息
*/ 
// 获取系统通知和活动未读消息数
export const getUnreadNumber = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/notice/unreadNumber', paramObj);
}


// 系统通知消息列表
export const getNoticeList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/notice/page', paramObj);
}
// 系统通知消息详情
export const getNoticeDetails = (paramObj) => {
	return getRequest(Url.HOST+`/usermanage/notice/details?noticeId=${paramObj.noticeId}`);
}







/**
 * @大转盘
*/ 
// 获取抽奖信息
export const getWheel = (paramObj) => {
	return getRequest(Url.HOST+'/game/reward/list', paramObj);
}

// 抽奖1
export const wheelOne = (paramObj) => {
	return getRequest(Url.HOST+'/game/reward/lotteryOne', paramObj);
}

// 抽奖2
export const wheelToo = (paramObj) => {
	return getRequest(Url.HOST+'/game/reward/lotteryTwo', paramObj);
}

// 抽奖3
export const wheelThree = (paramObj) => {
	return getRequest(Url.HOST+'/game/reward/lotteryThree', paramObj);
}


/**
 * @充值
*/ 
// 获取充值套餐列表
export const getPackageList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/apply/list', paramObj);
}

// 创建充值订单
export const rechargeOrder = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/rechargeOrder/add', paramObj);
}

// 生成订单签名
export const orderSign = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/rechargeOrder/sign', paramObj);
}

// payStack支付完成验证
export const payStackBack = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/rechargeOrder/payStackBack', paramObj);
}

// 产品配置接口
export const getProductList = () => {
	return getRequest(Url.HOST+'/usermanage/globalConfig/getList');
}


/**
 * @提现
*/ 
// 申请提现
export const applicationWithdrawal = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/apply/add', paramObj);
}

// 验证opay账号
export const checkAccountNumber = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userBank/checkAccountNumber', paramObj);
}

// 验证Paystack账号
export const checkBank = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userBank/validatePayStackBankAccount', paramObj);
}

// 验证PalmPay账号
export const queryAccount = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userBank/validatePalmPayBankAccount', paramObj);
}

// 获取Paystack第三方银行列表
export const thirdBankList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/userBank/thirdBankList', paramObj);
}
// 获取PalmPay第三方银行列表
export const queryBankList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/userBank/queryBankList', paramObj);
}

// 获取银行列表
export const getBankList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/userBank/bankList', paramObj);
}

// 获取用户绑定银行卡列表
export const getUserBank = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/userBank/listByPayCode', paramObj);
}

// 用户添加银行卡
export const addUserBank = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userBank/addNew', paramObj);
}

// 用户删除银行卡
export const removeUserBank = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userBank/removeOne', paramObj);
}

// 用户修改银行卡
export const editDefBack = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/userBank/setDefault', paramObj);
}





/**
 * @交易记录
*/ 
// 获取交易记录
export const getTransactions = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/detail/transactions', paramObj);
}


/**
 * @推荐 
*/ 
// 推荐计划首页
export const getRecommendPlan = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/team/queryInviteInfo', paramObj);
}

// 获取我推荐的朋友列表
export const getFriends = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/team/friends', paramObj);
}

// 获取我推荐的历史记录
export const referralPlanList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/detail/referralPlanList', paramObj);
}

















/**
 * @活动
*/ 
// 获取活动列表
export const getActivityList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/activity/page', paramObj);
}

// 获取活动详情
export const getActivityDetails = (paramObj) => {
	return getRequest(Url.HOST+`/usermanage/activity/details?activityId=${paramObj.activityId}`);

}




/**
 * @记录
*/ 
// 获取活动列表
export const getBetHistory = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/detail/betHistory', paramObj);
}

// 获取玩过的列表
export const getPlayedGames = (paramObj) => {
	return getRequest(Url.HOST+'/game/games/playedGames', paramObj);
}





/**
 * @联盟
*/ 
// 推荐计划首页
export const recommendPlan = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/team/recommendPlan', paramObj);
}

// 推荐等级信息
export const teamInfo = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/team/info', paramObj);
}

// 存款佣金记录
export const depositHistory = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/detail/depositHistory', paramObj);
}
// 存款佣金记录
export const depositCommission = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/team/depositCommission', paramObj);
}
// 领取存款佣金奖励
export const receiveDepositRewards = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/team/receiveDepositRewards', paramObj);
}

// 投注佣金记录
export const bettingReferralPlanList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/detail/referralPlanList', paramObj);
}

// 我的记录信息
export const myRecords = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/team/myRecords', paramObj);
}

// 我的收入历史记录
export const invitationHistory = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/detail/invitationHistory', paramObj);
}






/**
 * @常见问题
*/ 
// 常见问题列表
export const noticeList = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/index/noticeList', paramObj);
}

// 
export const notice = (paramObj) => {
	return getRequest(Url.HOST+'/usermanage/index/notice', paramObj);
}

// 
export const eventAdd = (paramObj) => {
	return postRequest(Url.HOST+'/usermanage/event/add', paramObj);
}


// 解析传入参数
const analyzePar = (params) => {
	let str = ""
	for (let k in params) {
		str += '/' + params[k]
	}
	return str
}

